/**
 * Label formatting helpers for the configuration editor.
 */

/**
 * Converts raw field labels to title-case.
 *
 * Rules:
 * - If the string contains any non-alphanumeric-or-underscore characters
 *   (e.g. spaces, dots, dashes, unicode punctuation), it is returned as-is.
 *   This handles identifier-style labels like "184221 · Direct Digital — National".
 * - If the string has no underscores and already starts with an uppercase letter,
 *   it is returned as-is ("Campaign", "Line items").
 * - Otherwise, splits on underscores and title-cases each word
 *   ("ad_group_ad" → "Ad Group Ad").
 */
export function titleCaseLabel(raw: string): string {
  if (/[^a-z0-9_]/.test(raw)) return raw;
  if (!raw.includes('_') && raw[0] === raw[0]?.toUpperCase()) return raw;
  return raw
    .split('_')
    .filter(Boolean)
    .map((w) => w[0].toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}
